import React, { useCallback, useState, forwardRef } from 'react';
import { Grid, IconButton, InputAdornment, makeStyles } from '@material-ui/core';
import { TextField, Typography as SwagupTypography } from '@swagup-com/components';
import SearchIcon from '@material-ui/icons/Search';
import CancelIcon from '@material-ui/icons/Cancel';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import debounce from 'lodash/debounce';
import { shoppingExperienceColors } from '../constants';
import styles from './common.styles';
import { setSearchTerm, triggerSearch } from '../../redux/searchReducer';
import { useResponsive } from '../../hooks';

const useStyles = makeStyles(styles);

// * allow letters, digits, spaces and “-”, using other symbols will be potentioal for XSS or other injection attacks
const ALLOWED_SEARCH_CHARS_REGEX = /[A-Za-z0-9 \-]/g;

const SearchBar = forwardRef(({ onClose }, ref) => {
  const classes = useStyles();
  const { isMobile } = useResponsive();
  const dispatch = useDispatch();
  const history = useHistory();
  const searchTerm = useSelector(state => state.search.searchTerm);
  const [searchWord, setSearchWord] = useState('' || searchTerm);
  const doNotDisableSearch = searchWord.trim().length >= 2;
  const disableSearch = searchWord.trim().length < 2;

  const debouncedTriggerSearch = useCallback(
    debounce(schWord => {
      dispatch(triggerSearch(schWord, onClose, history));
    }, 300),
    [dispatch, onClose, history]
  );

  const handleSearchChange = e => {
    const raw = e.target.value;
    const filtered = (raw.match(ALLOWED_SEARCH_CHARS_REGEX) || []).join('');
    setSearchWord(filtered);
  };

  const handleSearchWithClose = () => {
    if (doNotDisableSearch) {
      debouncedTriggerSearch(searchWord);
      if (onClose) onClose();
    }
  };

  const handleClearSearch = () => {
    setSearchWord('');
    // dispatch(setSearchTerm(''));
    // history.push('/search');
  };

  return (
    <Grid item>
      <TextField
        className={classes.searchBarTextField}
        variant="outlined"
        value={searchWord}
        onChange={handleSearchChange}
        onKeyPress={e => {
          if (e.key === 'Enter' && doNotDisableSearch) {
            handleSearchWithClose();
          }
        }}
        inputRef={ref}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {searchWord ? (
                <IconButton onClick={handleClearSearch}>
                  <CancelIcon style={{ color: shoppingExperienceColors.textPrimary, fontSize: '30px' }} />
                </IconButton>
              ) : (
                <IconButton onClick={handleSearchWithClose} disabled={disableSearch}>
                  <SearchIcon
                    style={{
                      color: disableSearch ? shoppingExperienceColors.disabledCta : shoppingExperienceColors.textPrimary
                    }}
                  />
                </IconButton>
              )}
            </InputAdornment>
          ),
          className: classes.searchInput,
          placeholder: 'Search products'
        }}
      />
      {!isMobile && (
        <SwagupTypography
          variant="body4ItalicInter"
          style={{ paddingTop: '10px', marginLeft: '30px', color: shoppingExperienceColors.info }}
        >
          Search by name, keyword, or phrase, only the dash (-) special character is supported
        </SwagupTypography>
      )}
    </Grid>
  );
});

export default SearchBar;
